import { ReactNode } from "react";

import { cn } from "@/lib/cn";

interface TextLinkProps {
  href: string;
  children: ReactNode;
  download?: boolean;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  className?: string;
}

export const TextLink = ({ href, children, download, onClick, className }: TextLinkProps) => {
  return (
    <a
      href={href}
      download={download}
      onClick={onClick}
      className={cn("text-sm font-bold text-primary-fg hover:underline", className)}
    >
      {children}
    </a>
  );
};
